module.exports = __webpack_public_path__ + "img/verifikasi-web-icon-1.d91bb579.svg";